import { createFileRoute } from '@tanstack/react-router';
import {
  cachedApprovedOrganization,
  pastEventsQuery,
  upcomingEventsQuery,
} from '@/features/organizer/api';
import { SettingsPage } from '@/features/organizer/pages/SettingsPage';
import { isCurator } from '@/features/organizer/vocab';
import { session } from '@/lib/auth/session';
import { belgradeToday } from '@/lib/format/format';

export const Route = createFileRoute('/_authed/org/$organizationId/settings')({
  staticData: { help: 'settings' },
  loader: ({ context: { queryClient }, params }) => {
    // Only the owner's page counts events, to say whether the organization can be deleted.
    const organization = cachedApprovedOrganization(queryClient, params.organizationId);
    if (!organization || isCurator(organization)) return;
    if (organization.ownerId !== session.get()?.user.userId) return;
    const today = belgradeToday();
    void queryClient.prefetchQuery(upcomingEventsQuery(organization, today));
    void queryClient.prefetchQuery(pastEventsQuery(organization, today));
  },
  component: SettingsPage,
});
